/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaEsercenteSelfListFilter { 
    comune_slug?: string;
    stato?: PraticaEsercenteSelfListFilterStatoEnum;
    tipo_pratica_id?: string;
    q?: string;
}
export enum PraticaEsercenteSelfListFilterStatoEnum {
    IN_VALUTAZIONE = 'IN_VALUTAZIONE',
    IN_CONVENZIONE = 'IN_CONVENZIONE',
    ABILITATA = 'ABILITATA',
    DISABILITATA = 'DISABILITATA',
    RIFIUTATA = 'RIFIUTATA',
    RITIRATA = 'RITIRATA'
};



